import React, { useState } from "react";
import "./TranslatorHubHeader.css";
import { Link } from "gatsby";
import TomedesLogo from "assets/images/Tomedes_Logo.svg";

function TranslatorHeader({title}) {
  return (
    <>
      <div className="w-full bg-[#585858]">
        <header className="translator-header translator-header_desktop w-full max-w-7xl mx-auto">
          <nav className="translator-nav" style={{ display: "flex", justifyContent: "center" }}>
            <Link to="/quote" className="translator-btn_signin">
              SIGN IN
            </Link>
            <Link to="/contactus.php">CONTACT US</Link>

            <Link to="/contactus.php">LIVE HELP</Link>
          </nav>
          <div>
            <Link to="/">
              <img src={TomedesLogo} alt="Tomedes logo" className="translator-logo" />
            </Link>
          </div>
          <div>
            <h4 className="translator-h4">{title}</h4>
          </div>
        </header>
      </div>

      {/* Mobile Version */}
      <header className="translator-header_mobile md:hidden flex items-center justify-between h-[50px] " style={{ paddingBottom: "0" }}>
        <Link to="/">
          <img src={TomedesLogo} alt="Tomedes logo" className="translator-logo" />
        </Link>
        <div className="translator-hamburger" onClick={() => document.body.classList.toggle("open")}>
          <span className="translator-hamburger_top"></span>
          <span className="translator-hamburger_middle"></span>
          <span className="translator-hamburger_bottom"></span>
        </div>
        <nav className="translator-mobile_nav text-white">
          <Link to="/contactus.php">CONTACT US</Link>
          <Link to="/contactus.php">LIVE HELP</Link>
          <Link to="/quote" className="translator-btn_signin">
            Sign In
          </Link>
          <select id="globe-lang" style={{ color: "#000" }} onChange={(e) => window.open(e.target.value, "_self")}>
            <option selected>SELECT LANGUAGE</option>
            <option value="https://www.tomedes.com/">English</option>
            <option value="https://es.tomedes.com/">Español</option>
            <option value="https://cn.tomedes.com/">简体中文</option>
            <option value="https://tw.tomedes.com/">中國傳統的</option>
            <option value="https://de.tomedes.com/">Deutsch</option>
            <option value="https://fr.tomedes.com/">Français</option>
            <option value="https://nl.tomedes.com/">Nederlands</option>
            <option value="https://www.tomedes.co.il/">עברית</option>
            <option value="https://jp.tomedes.com/">日本語</option>
            <option value="https://kr.tomedes.com/">한국어</option>
            <option value="https://no.tomedes.com/">Norsk</option>
            <option value="https://pl.tomedes.com/">Polski</option>
            <option value="https://ro.tomedes.com/">Româna</option>
            <option value="https://sv.tomedes.com/">Svenska</option>
            <option value="https://tr.tomedes.com/">Türk</option>
            <option value="https://ru.tomedes.com/">Русский</option>
          </select>
        </nav>
      </header>
    </>
  );
}

export default TranslatorHeader;
